<template>
  <svg width="15" height="13" viewBox="0 0 15 13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.36122 12.75L14.3613 0H0L7.36122 12.75Z" fill="currentColor"/>
  </svg>
</template>